import { JSX } from 'preact';

type CardGridProps = {
  children: JSX.Element | JSX.Element[];
  class?: string;
};

export function CardGrid({ children, class: className }: CardGridProps): JSX.Element {
  return (
    <div
      class={`grid grid-cols-1 @lg:grid-cols-2 @4xl:grid-cols-3 @lg:gap-8 @sm:gap-6 gap-4 ${className || ''}`}
    >
      {children}
    </div>
  );
}
